var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var Blank = /** @class */ (function (_super) {
    __extends(Blank, _super);
    function Blank() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Blank.prototype.render = function () {
        var seat = this.props.seat;
        return (React.createElement("div", { className: "selectable blank", "data-seat": JSON.stringify(seat) }));
    };
    return Blank;
}(Component));
export default Blank;



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/SeatPicker/Blank.tsx
// module id = 1296
// module chunks = 0